import request from './index'





// 获取分类条目列表
export function getCategoriesByParentId(parentId) {
	return request({
		url: '/cms/app/categories/getCategoriesByParentId?parentId=' + parentId,
		method: 'get'
	})
}



// 获取分类条目列表
export function getCategories(parentId) {
	return request({
		url: '/cms/web/getCategoriesByParentId?parentId=' + parentId,
		method: 'get'
	})
}





// 获取广告的轮播图
export function getBannerList() {
	return request({
		url: '/cms/web/getBannerListByRandomSort',
		method: 'get'
	})
}



// 获取商家列表
export function getShopList(count) {
	return request({
		url: '/business/web/getNewsRegBusiness/' + count,
		method: 'get'
	})
}